/* eslint-disable camelcase */
import { Route } from './Route'
import { CriticalEvent } from '../map/CriticalEvent'
import { UserFeedback } from './UserFeedback'
import { UserFeedbackDangerousState } from '../../enum'
import { User } from '../user/User'

import { travelDateLocalized } from '../../utils/travels'

export class Travel {
  constructor ({ user = {}, datetimestart = 0, datetimefinish = 0, temp_start = 0, temp_finish = 0, travel_id = -1, route = {}, critical_events = [], user_feedback = [], app_version = null, measurements = '{}' } = {}) {
    this.user = new User(user)
    this.travelId = travel_id
    this.datetimestart = new Date(datetimestart)
    this.datetimefinish = new Date(datetimefinish)
    this.tempStart = new Date(temp_start)
    this.tempFinish = new Date(temp_finish)
    this.route = new Route(route)
    this.criticalEvents = critical_events.map((event, index) => new CriticalEvent({ ...event, index }))
    this.feedback = user_feedback.map(feedbackEntry => new UserFeedback(feedbackEntry))
    this.appVersion = app_version
    this.activeCriticalEvent = null // link to the active critical event on map
    this.measurements = typeof measurements === 'object' ? measurements : JSON.parse(measurements)
  }

  get formattedTravelStartTime () {
    return travelDateLocalized(this.datetimestart)
  }

  get formattedTempTravelStartTime () {
    return travelDateLocalized(this.tempStart)
  }

  get formattedTravelFinishTime () {
    return travelDateLocalized(this.datetimefinish)
  }

  get formattedTempTravelFinishTime () {
    return travelDateLocalized(this.tempFinish)
  }

  isTravelExists () {
    return this.travelId !== -1
  }

  isFeedbackExists () {
    return this.feedback.length > 0
  }

  get drowsinessFeedback () {
    if (!this.isFeedbackExists()) {
      return new UserFeedback()
    } else {
      return this.feedback.find(feedbackEntry => feedbackEntry.dangerousState === UserFeedbackDangerousState.DROWSINESS)
    }
  }

  get aggressivenessFeedback () {
    if (!this.isFeedbackExists()) {
      return new UserFeedback()
    } else {
      return this.feedback.find(feedbackEntry => feedbackEntry.dangerousState === UserFeedbackDangerousState.AGGRESSIVENESS)
    }
  }

  setActiveCriticalEvent (criticalEventId) {
    this.activeCriticalEvent = criticalEventId
  }
}
